import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from '@/components/Layout';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Users from '@/pages/Users';
import Subscriptions from '@/pages/Subscriptions';
import Analytics from '@/pages/Analytics';
import Content from '@/pages/Content';
import LLMConfig from '@/pages/LLMConfig';
import SystemHealth from '@/pages/SystemHealth';
import Config from '@/pages/Config';
import SubjectRequests from '@/pages/SubjectRequests';
import Courses from '@/pages/Courses';
import Blog from '@/pages/Blog';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<Layout />}>
          <Route path="/"              element={<Dashboard />} />
          <Route path="/users"         element={<Users />} />
          <Route path="/subscriptions" element={<Subscriptions />} />
          <Route path="/analytics"     element={<Analytics />} />
          <Route path="/content"       element={<Content />} />
          <Route path="/llm-config"    element={<LLMConfig />} />
          <Route path="/system"        element={<SystemHealth />} />
          <Route path="/config"            element={<Config />} />
          <Route path="/subject-requests" element={<SubjectRequests />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/blog" element={<Blog />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
